import { TokenRenewMode } from '@axa-fr/react-oidc';
import { env } from 'utils/env';

export const root = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
const AUTH = {
  CALLBACK: '/authentication/callback',
  SILENT_CALLBACK: '/authentication/silent_callback'
};

const getAuthenticationConfiguration = () => {
  return {
    client_id: env.REACT_APP_IDENTITY_CLIENT_ID,
    authority: env.REACT_APP_IDENTITY_AUTHORITY,
    redirect_uri: `${root}${AUTH.CALLBACK}`,
    silent_redirect_uri: `${root}${AUTH.SILENT_CALLBACK}`,
    scope: 'openid profile ' + env.REACT_APP_IDENTITY_SCOPE,
    refresh_time_before_tokens_expiration_in_second: 40,
    token_renew_mode: TokenRenewMode.access_token_invalid,
    extras: { acr_values: env.REACT_APP_ACR_VALUES },
    service_worker_only: false,
    //when we use OidcServiceWorker, the id token handleing breaks when communicating with other LSNG apps (Origination, MasterPartner etc)
    // service_worker_relative_url: '/OidcServiceWorker.js',
    storage: sessionStorage,
    monitor_session: true,
    demonstrating_proof_of_possession: true,
    defaultDemonstratingProofOfPossessionConfiguration: {
      importKeyAlgorithm: {
        name: 'ECDSA',
        namedCurve: 'P-256',
        hash: { name: 'ES256' }
      },
      signAlgorithm: { name: 'ECDSA', hash: { name: 'SHA-256' } },
      generateKeyAlgorithm: {
        name: 'ECDSA',
        namedCurve: 'P-256'
      },
      digestAlgorithm: { name: 'SHA-256' },
      jwtHeaderAlgorithm: 'ES256'
    }
  };
};

export default getAuthenticationConfiguration;
